import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'

export const EventDetailsLoadingSkeleton = () => {
  return (
    <Card className="h-full">
      <Card.Content>
        <div className="flex flex-col gap-y-4 sm:grid sm:grid-cols-[1fr_2fr] gap-x-4 animate-pulse">
          <div className="flex flex-col gap-y-3">
            {/* Cover image and title */}
            <div className="flex flex-col gap-y-1">
              <div className="w-full aspect-[5/4] rounded-md bg-skeleton" />
              <div className="h-6 bg-skeleton rounded w-3/4" />
            </div>

            {/* Hosted by */}
            <div className="flex gap-x-2 items-center">
              <div className="rounded-avatar bg-skeleton h-12 w-12" />
              <div className="flex flex-col gap-y-2 flex-1">
                <div className="h-4 bg-skeleton rounded w-24" />
                <div className="h-4 bg-skeleton rounded w-1/2" />
              </div>
            </div>

            {/* Time */}
            <div className="flex gap-x-2 items-center">
              <div className="text-sm rounded-md bg-skeleton w-12 h-12 flex items-center justify-center" />
              <div className="flex flex-col gap-y-2 flex-1">
                <div className="h-4 bg-skeleton rounded w-32" />
                <div className="h-4 bg-skeleton rounded w-3/4" />
              </div>
            </div>

            {/* Time and Location */}
            <div className="flex gap-x-2 items-center">
              <div className="text-sm rounded-md bg-skeleton w-12 h-12 flex items-center justify-center" />
              <div className="flex flex-col gap-y-2 flex-1">
                <div className="h-4 bg-skeleton rounded w-40" />
                <div className="h-4 bg-skeleton rounded w-3/5" />
              </div>
            </div>

            {/* Action Buttons (desktop) */}
            <div className="hidden sm:block py-4">
              <Divider padding="none" />
              <div className="flex flex-col gap-y-2 text-center py-4">
                <div className="h-5 bg-skeleton rounded w-1/3 mx-auto" />
                <div className="h-4 bg-skeleton rounded w-2/3 mx-auto" />
              </div>
              <div className="h-10 bg-skeleton rounded-base w-full" />
            </div>
          </div>

          <div className="flex flex-col gap-y-5">
            {/* About event */}
            <div>
              <div className="h-5 bg-skeleton rounded w-28" />
              <Divider padding="sm" />
              <div className="space-y-3">
                <div className="h-4 bg-skeleton rounded w-full" />
                <div className="h-4 bg-skeleton rounded w-5/6" />
                <div className="h-4 bg-skeleton rounded w-11/12" />
                <div className="h-4 bg-skeleton rounded w-10/12" />
              </div>
            </div>

            {/* Location map */}
            <div>
              <div className="h-5 bg-skeleton rounded w-24" />
              <Divider padding="sm" />
              <div className="bg-skeleton rounded-md h-56 w-full" />
            </div>
          </div>
        </div>

        {/* Action Buttons (mobile) */}
        <div className="block sm:hidden sticky -bottom-1 bg-surface">
          <Divider padding="none" />
          <div className="flex flex-col gap-y-2 text-center py-4">
            <div className="h-5 bg-skeleton rounded w-1/3 mx-auto" />
            <div className="h-4 bg-skeleton rounded w-2/3 mx-auto" />
          </div>
          <div className="h-10 bg-skeleton rounded-base w-full" />
        </div>
      </Card.Content>
    </Card>
  )
}
